export const eqSet = <T>(xs: Set<T>, ys: Set<T>) =>
    xs.size === ys.size &&
    [...xs].every((x) => ys.has(x))
